module.exports = __webpack_public_path__ + "static/media/18.09f469f0.jpg";